<template>
  <div>
    <v-list>
      <ListItem
        :title="role.id"
        :subtitle="$t('fields.id')"
      />
      <ListItem
        :title="role.name"
        :subtitle="$t('fields.name')"
      />
    </v-list>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';

  import ListItem from '../../shared/Lists/ListItem';

  export default {
    name: 'RoleDetails',
    components: { ListItem },
    props: {
      role: {
        type: Object,
        default: () => {},
      },
    },
    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('alert', ['showToast']),
    },
  };
</script>
